import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './components/RequireAuth.tsx';
import { SiAlgoSeRompe } from './components/SiAlgoSeRompe';
import { SoloOperador } from './components/SoloOperador.tsx';
import { ToastContainer } from './components/Toast.tsx';
import { WebSocketProvider } from './hooks/WebSocketProvider.tsx';
import { AuthProvider } from './hooks/useAuth.tsx';
import { ChangePasswordPage } from './pages/ChangePasswordPage.tsx';
import { ContactDetailPage } from './pages/ContactDetailPage.tsx';
import { ContactsListPage } from './pages/ContactsListPage.tsx';
import { ConversationsMetricsPage } from './pages/ConversationsMetricsPage.tsx';
import { ConversationsWorkspace } from './pages/ConversationsWorkspace.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { MetricsPage } from './pages/MetricsPage.tsx';
import { MetricsRedirect } from './pages/MetricsRedirect.tsx';
import { PaginaDeProbar } from './pages/PaginaDeProbar';
import { TenantCreateWizard } from './pages/TenantCreateWizard.tsx';
import { TenantDetailPage } from './pages/TenantDetailPage.tsx';
import { TenantListPage } from './pages/TenantListPage.tsx';
import { TicketsPage } from './pages/TicketsPage.tsx';
import { UsersPage } from './pages/UsersPage.tsx';
import { PuertaDelAlta } from './pages/alta/PuertaDelAlta.tsx';
import { PaginaDeCanales } from './pages/configuracion/PaginaDeCanales';

export function App() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <ToastContainer />
        {/* Sin esto, cualquier error de React deja el panel EN BLANCO: sin
            mensaje, sin forma de volver, y sin rastro del lado de quien lo
            sufre (GKTIBO-117). */}
        <SiAlgoSeRompe>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/change-password" element={<ChangePasswordPage />} />

            {/* Protected — require JWT */}
            <Route
              path="/tenants"
              element={
                <RequireAuth>
                  <TenantListPage />
                </RequireAuth>
              }
            />
            <Route
              path="/tenants/new"
              element={
                /* Dar de alta un tenant es acción NUESTRA. Sin `SoloOperador` el
                 dueño llegaba acá escribiendo la URL, llenaba el wizard y
                 recibía el 403 al guardar. */
                <RequireAuth>
                  <SoloOperador>
                    <TenantCreateWizard />
                  </SoloOperador>
                </RequireAuth>
              }
            />

            {/* El alta que ve el DUEÑO, no el operador. `/tenants/new` es el
              wizard nuestro; esto es lo que recorre quien se registró solo.

              PÚBLICA a propósito: sin sesión muestra el registro, con sesión la
              configuración. Meterla dentro de `RequireAuth` reintroduce el bug
              de «la página de alta me regresa al login», porque no habría forma
              de crear la cuenta. */}
            <Route path="/alta" element={<PuertaDelAlta />} />

            <Route
              path="/tenants/:tenantId"
              element={
                <RequireAuth>
                  <TenantDetailPage />
                </RequireAuth>
              }
            />

            <Route
              path="/tenants/:tenantId/metrics"
              element={
                <RequireAuth>
                  <MetricsPage />
                </RequireAuth>
              }
            />

            {/* Workspace master-detail: la lista queda visible al abrir un chat.
              Ambas rutas montan el mismo componente; la selección vive en la URL. */}
            <Route
              path="/conversations"
              element={
                <RequireAuth>
                  <ConversationsWorkspace />
                </RequireAuth>
              }
            />

            {/* La misma pantalla del alta, disponible después (C7): el
              conocimiento cambia y hay que poder reprobar el bot sin esperar
              a que le escriba un cliente. */}
            <Route
              path="/probar"
              element={
                <RequireAuth>
                  <PaginaDeProbar />
                </RequireAuth>
              }
            />

            <Route
              path="/metrics"
              element={
                <RequireAuth>
                  <MetricsRedirect />
                </RequireAuth>
              }
            />
            <Route
              path="/conversations/metrics"
              element={
                <RequireAuth>
                  <ConversationsMetricsPage />
                </RequireAuth>
              }
            />

            <Route
              path="/conversations/:tenantId/:userId"
              element={
                <RequireAuth>
                  <ConversationsWorkspace />
                </RequireAuth>
              }
            />

            {/* Los canales salieron del alta (GKTIBO-125): el dueño los
                conectaba antes de haber visto a su bot contestar una vez. */}
            <Route
              path="/configuracion/canales"
              element={
                <RequireAuth>
                  <PaginaDeCanales />
                </RequireAuth>
              }
            />

            <Route
              path="/users"
              element={
                <RequireAuth>
                  <UsersPage />
                </RequireAuth>
              }
            />

            <Route
              path="/contacts"
              element={
                <RequireAuth>
                  <ContactsListPage />
                </RequireAuth>
              }
            />

            <Route
              path="/contacts/:tenantId/:userId"
              element={
                <RequireAuth>
                  <ContactDetailPage />
                </RequireAuth>
              }
            />

            <Route
              path="/tickets"
              element={
                <RequireAuth>
                  <TicketsPage />
                </RequireAuth>
              }
            />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/tenants" replace />} />
            <Route path="*" element={<Navigate to="/tenants" replace />} />
          </Routes>
        </SiAlgoSeRompe>
      </WebSocketProvider>
    </AuthProvider>
  );
}
